import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { UserOrder } from '../../../models/shopping';
import { Price } from '../../common/price/price';
import { UserOrderItemListItem } from '../user-order-item-list-item/user-order-item-list-item';

@Component({
  selector: 'app-user-order-details-panel',
  imports: [DecimalPipe, Price, UserOrderItemListItem, DatePipe],
  templateUrl: './user-order-details-panel.html',
  styleUrl: './user-order-details-panel.scss',
})
export class UserOrderDetailsPanel {
  @Input({ required: true }) order!: UserOrder;
}
